<template>
    <div class="container">
        <div v-if="!domain">
            <font-awesome-icon icon="spinner" spin></font-awesome-icon>
        </div>
        <div v-if="domain">
            <h1>Статистика <span class="d-none d-md-inline">по сайту {{domain? domain.domain_name : 'net'}}</span></h1>
            <div class="d-flex flex-wrap">
                <div class="mr-2">
                    <div class="label d-inline-block">С</div>
                    <dx-date-box class="d-inline-block"
                                 v-model="beginDate"
                                 display-format="shortdate"
                                 type="date"
                    />
                </div>
                <div>
                    <div class="label d-inline-block">по</div>
                    <dx-date-box class="d-inline-block"
                                 v-model="endDate"
                                 display-format="shortdate"
                                 type="date"
                    />
                </div>
                <div class="label d-inline-block ml-2">
                    <dx-check-box class=""
                                  v-model="groupBySource"
                                  text="По источникам"
                    />
                </div>
            </div>
            <div v-if="!loaded">
                <font-awesome-icon icon="spinner" spin></font-awesome-icon>
            </div>
            <div v-if="loaded" style="overflow-y: auto">
                <table class="table table-bordered table-sm table-hover w-100">
                    <thead class="thead-light">
                    <tr>
                        <th>
                            <font-awesome-icon icon="file" class="d-inline d-sm-none"></font-awesome-icon>
                            <span class="d-none d-sm-inline">{{ groupBySource ? 'Источник' : 'Страница' }}</span>
                        </th>
                        <th class="d-none d-sm-table-cell">Просмотров</th>
                        <th>
                            <font-awesome-icon icon="user" class="d-inline d-sm-none"></font-awesome-icon>
                            <span class="d-none d-sm-inline">Посетителей</span>
                        </th>
                        <th>
                            <font-awesome-icon icon="shopping-cart" class="d-inline d-sm-none"></font-awesome-icon>
                            <span class="d-none d-sm-inline">Заявки</span></th>
                        <th>
                            <font-awesome-icon icon="percentage" class="d-inline d-sm-none"></font-awesome-icon>
                            <span class="d-none d-sm-inline">Конверсия</span></th>
                    </tr>
                    </thead>


                    <tbody>
                    <!-- Весь сайт-->
                    <tr class="table-warning font-weight-bold">
                        <td>Весь сайт</td>
                        <td class="d-none  d-sm-table-cell"><b>{{totals.visits_count}}</b></td>
                        <td><b>{{totals.unique_visits_count}}</b></td>
                        <td><b>{{totals.lead_count}}</b></td>
                        <td><b>{{conversion(totals)}}</b>
                        </td>
                    </tr>

                    <!-- Детализация по всему сайту -->
                    <tr v-for="group in groups"
                        :key="groupBySource ? (group.lead_source || 'Без источника') : group.page_name"
                        :class="{'table-success': group.lead_count > 0}">
                        <td>
                            <div class="firstColumn">
                                {{groupBySource ? (group.lead_source || 'Без источника') : group.page_name}}
                            </div>
                        </td>
                        <td class="d-none  d-sm-table-cell">{{ group.visits_count }}</td>
                        <td>{{ group.unique_visits_count }}</td>
                        <td>
                            <router-link
                                    :to="{name:'lead', query:{page_name:group.page_name, lead_source: group.lead_source}}"
                                    v-if="group.lead_count">
                                {{ group.lead_count }}
                            </router-link>
                        </td>
                        <td>{{conversion(group) }}
                        </td>
                    </tr>


                    <!-- Детализация по страницам -->
                    <tr class="font-weight-bold table-warning">
                        <td colspan="5">Детализация по страницам</td>
                    </tr>
                    <template v-for="page in report.summaryByPage">
                        <tr class="font-weight-bold table-info" :key="'page_'+page.page_name">
                            <td>
                                <div class="firstColumn">{{page.page_name}}</div>
                            </td>
                            <td class="d-none  d-sm-table-cell">{{page.visits_count}}</td>
                            <td>{{page.unique_visits_count}}</td>
                            <td>{{page.lead_count}}</td>
                            <td>{{conversion(page)}}
                            </td>
                        </tr>
                        <template v-for="detail in pageDetail(page.page_name)">
                            <tr :key="'detail_'+page.page_name+'_'+detail.lead_source"
                                :class="{'table-success': detail.lead_count > 0}">
                                <td>
                                    <div class="firstColumn">{{detail.lead_source || 'Без источника'}}</div>
                                </td>
                                <td class="d-none  d-sm-table-cell">{{ detail.visits_count }}</td>
                                <td>{{ detail.unique_visits_count }}</td>
                                <td>
                                    <router-link
                                            :to="{name:'lead', query:{page_name:detail.page_name, lead_source: detail.lead_source}}"
                                            v-if="detail.lead_count">
                                        {{ detail.lead_count }}
                                    </router-link>

                                </td>
                                <td>{{conversion(detail) }}</td>
                            </tr>
                        </template>
                    </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import axios from "axios";
    import {DxDateBox, DxCheckBox} from 'devextreme-vue';

    export default {
        name: "ReportIndex",
        data() {
            return {
                loaded: false,
                groupBySource: false,
                beginDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
                endDate: null,
                report: {
                    totals: [],
                    details: [],
                    summaryByPage: [],
                    summaryBySource: []
                }
            }
        },
        computed: {
            ...mapState({
                domainStatus: state => state.domains.status,
                domain: state => state.domains.selectedDomain,
            }),
            totals() {
                return this.report.totals[0]
            },
            groups() {
                return this.groupBySource ? this.report.summaryBySource : this.report.summaryByPage;
            }

        },
        methods: {
            load() {
                let app = this;
                app.loaded = false;
                app.report = [];

                if (this.domainStatus === 'success' && !this.domain) {
                    this.$router.push('/domain');
                }

                if (!this.domain) return;

                let beginDate = this._getFormattedBeginDate();
                let endDate = this._getFormattedEndDate();

                axios.post('/api/report/index/' + this.domain.id, {beginDate: beginDate, endDate: endDate})
                    .then(function (resp) {
                        app.report = resp.data;
                        app.loaded = true;
                    })
                    .catch(function () {
                        alert("Невозможно загрузить информацию о сайте");
                    });
            },

            _getFormattedBeginDate() {
                return this.beginDate.getFullYear() + '-' + (this.beginDate.getMonth() + 1) + '-' + this.beginDate.getDate()
            },

            _getFormattedEndDate() {
                if (this.endDate)
                    return this.endDate.getFullYear() + '-' + (this.endDate.getMonth() + 1) + '-' + this.endDate.getDate();
                else
                    return undefined;
            },

            conversion(row) {
                return row.unique_visits_count > 0 ?
                    Math.round(row.lead_count / row.unique_visits_count * 10000) / 100 +
                    '%'
                    : 0
            },

            pageDetail(page_name) {
                let result = [];
                this.report.details.forEach(function (detail) {
                    if (detail.page_name === page_name)
                        result.push(detail);
                });
                return result;
            },

            navigateToLeads(query) {
                this.$router.push({name: 'lead', query: query});
            }
        },
        created() {
            let query = this.$route.query;
            if (query.beginDate) {
                this.beginDate = new Date(query.beginDate);
            }
            if (query.endDate) {
                this.endDate = new Date(query.endDate);
            }
        },
        mounted() {
            this.load();
        },
        watch: {
            domain() {
                this.load();
            },
            domainStatus() {
                if (this.domainStatus === 'success' && !this.domain) {
                    this.$router.push('/domain');
                }
            },
            beginDate() {
                this.$router.push({
                    query: {
                        beginDate: this._getFormattedBeginDate(),
                        endDate: this._getFormattedEndDate()
                    }
                });
                this.load();
            },
            endDate() {
                this.$router.push({
                    query: {
                        beginDate: this._getFormattedBeginDate(),
                        endDate: this._getFormattedEndDate()
                    }
                });
                this.load();
            }
        },
        components: {DxDateBox, DxCheckBox}
    }
</script>

<style scoped>
    .label {
        padding: 8px 0.5rem 9px 0;
        vertical-align: top;
    }

    .firstColumn {
        text-overflow: ellipsis;
        max-width: 60vw;
        overflow: hidden;
    }
</style>